module.exports = __webpack_public_path__ + "media/images/sign_up_with_facebook-1f751eff78e97b840bdb5695c02387e7.png";